import React, { useState } from "react";
import PropTypes from "prop-types";
import "react-tabs/style/react-tabs.css";

import { generateUniqueId } from "../../../../utils";

import TabItem from "./TabItem";

const TabsContainer = ({
  contracts,
  projects,
  tickets,
  calls,
  isMobile,
  startMonth,
  startYear,
  endMonth,
  endYear
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <React.Fragment>
      {!!contracts.length && (
        <div
          className="itms-tabs"
          tabIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <React.Fragment>
            {contracts.map((contract) => {
              const tabProjects = projects.filter(
                (project) => project.contract === contract.id
              );
              const tabTickets = tickets.filter((ticket) =>
                tabProjects.some((project) => project.id === ticket.project)
              );
              const tabCalls = Array.isArray(calls)
                ? calls.filter((call) =>
                    tabProjects.some((project) => project.id === call.project)
                  )
                : [];
              return (
                <TabItem
                  key={generateUniqueId()}
                  contract={contract}
                  projects={tabProjects}
                  tickets={tabTickets}
                  calls={tabCalls}
                  isMobile={isMobile}
                  startMonth={startMonth}
                  startYear={startYear}
                  endMonth={endMonth}
                  endYear={endYear}
                />
              );
            })}
          </React.Fragment>
        </div>
      )}
      {!contracts.length && <div className="no-data">No Data Available</div>}
    </React.Fragment>
  );
};

TabsContainer.propTypes = {
  contracts: PropTypes.array,
  projects: PropTypes.array,
  tickets: PropTypes.array,
  calls: PropTypes.array,
  isMobile: PropTypes.bool,
  startMonth: PropTypes.string,
  startYear: PropTypes.string,
  endMonth: PropTypes.string,
  endYear: PropTypes.string
};

TabsContainer.defaultProps = {
  contracts: [],
  projects: [],
  tickets: [],
  calls: [],
  isMobile: false,
  startMonth: "0",
  startYear: "0",
  endMonth: "0",
  endYear: "0"
};

export default TabsContainer;
